import { render, staticRenderFns } from "./NewMusiconhold.vue?vue&type=template&id=1215cc7b&scoped=true&"
import script from "./NewMusiconhold.vue?vue&type=script&lang=js&"
export * from "./NewMusiconhold.vue?vue&type=script&lang=js&"
import style0 from "./NewMusiconhold.vue?vue&type=style&index=0&id=1215cc7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1215cc7b",
  null
  
)

export default component.exports